module.exports = __webpack_public_path__ + "img/steps.a98fc5ea.png";